import config from '../../config.json';
import packageDef from '../../package.json';

export const environment = {
  ...Object.assign({ version: packageDef.version }, config['common'], config['services-platform'])
};
